import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import api from "../../services/api";
import { getToken } from "../../services/auth";
import ModalForm from './Modal'

class DataTable extends Component {

  deleteItem = id => {
    let confirmDelete = window.confirm('Excluir o usuário definitivamente?')
    if (confirmDelete) {
      const token = getToken();
      api.delete('usuario/', {
        headers: {
          token
        },
        body: JSON.stringify({
          id
        })
      })
        .then(response => response.json())
        .then(user => {
          this.props.deleteItemFromState(id)
        })
        .catch(err => console.log(err))
    }

  }

  render() {
    const users = this.props.users.map(user => {
      return (
        <tr key={user.id}>
          <th scope="row">{user.id}</th>
          <td>{user.nome}</td>
          <td>{user.email}</td>
          <td>
            <div className="dropdown show acoes ">
              <Link className="btn btn-primary btn-sm dropdown-toggle" to="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fa fa-cog"></i>
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <Link to="#" className="dropdown-item" style={{display: 'inherit'}}>
                <ModalForm className="modal-lg" user={user} />
                </Link>
                <Link to="#" className="dropdown-item" style={{display: 'inherit', width: '155px'}}>
                  <div>
                    <p className="dropdown-item table-remove" style={{ marginRight: "10px" }} onClick={() => this.deleteItem(user.id)}> Remover <i className="fa fa-trash-alt"></i></p>
                  </div>
                </Link>
              </div>
            </div>
          </td>
        </tr>
      )
    })

    return (
      <Table className="table table-bordered mb-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>Email</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {users}
        </tbody>
      </Table>
    )
  }
}

export default DataTable